<template lang="pug">
  abstract-accepting-order-fields(
    :action_name="ActionName()"
    draft_action_name="edit"
    :accepting_order_id="accepting_order_id"
    :accepting_draft_order_id="accepting_draft_order_id"
    :button_label="buttonLabel()"
    draft_button_label="下書き更新"
  )
</template>

<script>
  import AbstractAcceptingOrderFields  from 'components/accepting_orders/abstract_accepting_order_fields'

  export default {
    name: 'edit-accepting-order-fields',
    components: { AbstractAcceptingOrderFields },
    data() {
      return {
      }
    },
    props: {
      accepting_order_id: {
        type: String,
        required: false
      },
      accepting_draft_order_id: {
        type: String,
        required: false
      }
    },
    methods: {
      ActionName() {
        if(this.accepting_order_id)
          return "edit"
        else if(this.accepting_draft_order_id)
          return "new"
      },
      buttonLabel() {
        if(this.ActionName() == "edit")
          return "更新"
        return "登録"
      }
    }
  }
</script>
